// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const More = createIcon(
  <path
    clipRule="evenodd"
    d="M13.8002 5.8C13.8002 6.79411 12.9943 7.6 12.0002 7.6C11.0061 7.6 10.2002 6.79411 10.2002 5.8C10.2002 4.80589 11.0061 4 12.0002 4C12.9943 4 13.8002 4.80589 13.8002 5.8ZM13.8002 12.0002C13.8002 12.9943 12.9943 13.8002 12.0002 13.8002C11.0061 13.8002 10.2002 12.9943 10.2002 12.0002C10.2002 11.0061 11.0061 10.2002 12.0002 10.2002C12.9943 10.2002 13.8002 11.0061 13.8002 12.0002ZM12.0002 20.0004C12.9943 20.0004 13.8002 19.1945 13.8002 18.2004C13.8002 17.2063 12.9943 16.4004 12.0002 16.4004C11.0061 16.4004 10.2002 17.2063 10.2002 18.2004C10.2002 19.1945 11.0061 20.0004 12.0002 20.0004Z"
    fillRule="evenodd"
  />,
);
